@if (thumbnail) {
<div [ngClass]="{ admin: admin }">
  @if (data.timestamp && data.cameraId) {
  <div style="position: relative;">
    <img [src]="thumbnail" [alt]="data.name" (error)="thumbnail = null" (click)="reelClick.emit(data)" style="cursor: pointer;" />
    @if (data.imageX !== 0 && data.imageY !== 0) {
    <div
      class="position-marker"
      [style.left.%]="data.imageX * 100"
      [style.top.%]="data.imageY * 100"
    ></div>
    }
  </div>
  } @else {
  <a [href]="data.url" target="_blank">
    <img [src]="thumbnail" [alt]="data.name" (error)="thumbnail = null" />
  </a>
  }

  <p>
    <app-multiline-translation [text]="data.name"></app-multiline-translation>
  </p>

  @if (admin) {
  <div class="controls">
    <button mat-button (click)="edit.emit(data)">Edit</button>
    <button mat-button (click)="remove.emit(data)">Delete</button>
  </div>
  }
</div>
}
@if (!thumbnail) {
<div [ngClass]="{ admin: admin }">
  <a [href]="data.url" target="_blank">
    <mat-card appearance="outlined" class="mat-elevation-z2">
      <mat-card-content style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
        @switch (data.kind) {
          @case (0) { <mat-icon>photo</mat-icon> }
          @case (1) { <mat-icon>bar_chart</mat-icon> }
          @case (2) { <mat-icon>videocam</mat-icon> }
          @case (3) { <mat-icon>insert_drive_file</mat-icon> }
        }
        <p>
          <app-multiline-translation [text]="data.name"></app-multiline-translation>
        </p>
      </mat-card-content>
    </mat-card>
  </a>
  @if (admin) {
  <div class="controls">
    <button mat-button (click)="edit.emit(data)">Edit</button>
    <button mat-button (click)="remove.emit(data)">Delete</button>
  </div>
  }
</div>
}
